import React from 'react';
import type { ArticleSection } from '../data/article';
interface ArticleSectionBlocksProps {
  sections: ArticleSection[];
}
export function ArticleSectionBlocks({
  sections
}: ArticleSectionBlocksProps) {
  return <>
      {sections.map(section => <section key={section.id} aria-labelledby={`${section.id}-heading`} className="mt-12 first:mt-0" data-id="element-13" data-mp="3ul46mkfgotc7">
          <h2 id={`${section.id}-heading`} className="font-serif text-[26px] font-bold leading-[1.25] tracking-[-0.01em] text-ink sm:text-[30px]" data-id="element-14" data-mp="3lma2m8zsx0om">
            {section.heading}
          </h2>

          {section.blocks.map((block, index) => {
        const key = `${section.id}-${index}`;
        if (block.type === 'subheading') {
          return <h3 key={key} className="mt-8 font-sans text-[15px] font-semibold tracking-[-0.005em] text-ink" data-id="element-15" data-mp="19wpvy8c48hb5">
                  {block.text}
                </h3>;
        }
        if (block.type === 'caseline') {
          return <p key={key} className="mt-6 border-l-2 border-ink pl-4 font-sans text-[13px] font-medium leading-[1.6] text-ink" data-id="element-16" data-mp="708h5un2qgmz">
                  {block.text}
                </p>;
        }
        if (block.type === 'note') {
          return <p key={key} className="mt-6 bg-paper-tint px-5 py-4 font-sans text-[14px] leading-[1.65] text-ink-soft" data-id="element-17" data-mp="3p64qa8km741u">
                  {block.text}
                </p>;
        }
        return <p key={key} className="mt-5 font-serif text-[18px] leading-[1.75] text-ink-soft" data-id="element-18" data-mp="3t6nja5y8ug5m" data-mpi={index}>
                {block.text}
              </p>;
      })}
        </section>)}
    </>;
}